import {
  ROYAL_BLUE_VIVID,
  ROYAL_BLUE,
  CONGRESS_BLUE,
  CHARADE_GREY
} from "../../../constants/colors";

const hoverColor = ROYAL_BLUE;
const activeColor = CONGRESS_BLUE;
const linkColor = ROYAL_BLUE_VIVID;
const textColor = CHARADE_GREY;

export const fallbackValues = {
  linkColor,
  hoverColor,
  activeColor,
  textColor
};
